// Retailer-attribute onboarding skill list — one entry per
// anomaly-healing-agent `src/agent/skills/attr-*` directory, mapped to its
// canonical `extract.*` / `feedback.*` identifier as heal jobs send it.
//
// Shape matches CreateRuleModal.js's ATTRIBUTE_TYPES ({value, label} pairs).
// Four directories are many-to-one in the source system and use a specific
// canonical pick (see plan U2 KTD3): video-url -> videoURL, image-url ->
// imageUrl, review-count -> commentCount, product-no -> productNo.
//
// extract.groupId is the exception to the "one entry per attr-* directory"
// rule above: there is no attr-group-id (or attr-groupId) skill directory
// yet, so onboarding it runs skill generation without a generic reference
// skill to fall back on (see agentic-anomaly-healing's
// skillGeneration.ts loadGenericAttributeSkill).
export const SKILL_ATTRIBUTES = [
  { value: 'feedback.avgRating', label: 'Average Rating' },
  { value: 'extract.brand', label: 'Brand' },
  { value: 'extract.bulletPoints', label: 'Bullet Points' },
  { value: 'extract.description', label: 'Description' },
  { value: 'extract.groupId', label: 'Group ID' },
  { value: 'extract.gtin', label: 'GTIN' },
  { value: 'extract.hasRichContent', label: 'Has Rich Content' },
  { value: 'extract.imageUrl', label: 'Image URL' },
  { value: 'extract.ingredients', label: 'Ingredients' },
  { value: 'extract.instructions', label: 'Instructions' },
  { value: 'extract.manufacturer', label: 'Manufacturer' },
  { value: 'extract.name', label: 'Name' },
  { value: 'extract.netQuantity', label: 'Net Quantity' },
  { value: 'extract.outOfStock', label: 'Out of Stock' },
  { value: 'extract.pricePerUnit', label: 'Price Per Unit' },
  { value: 'extract.productNo', label: 'Product Number' },
  { value: 'extract.price', label: 'Price' },
  { value: 'extract.promotionText', label: 'Promotion Text' },
  { value: 'feedback.commentCount', label: 'Comment Count' },
  { value: 'extract.sellerType', label: 'Seller Type' },
  { value: 'extract.sponsored', label: 'Sponsored' },
  { value: 'extract.videoURL', label: 'Video URL' },
];

export default SKILL_ATTRIBUTES;
